/**============================================================
*   [Class] プラン短冊型記事スライダー
============================================================*/
export default class PlanListSlider {
  constructor(
    target,
    key,
  )
  {
    this.swiperSlide = target;
    this.swiperKey = key;
    this.swiperSlide.classList.remove('swiper-disabled');
    this.swiperSlide.classList.add('swiper-plan-list-'+ this.swiperKey);
    let slidable = true;

    this.initSwiper = () => {
      this.mySwiper = new Swiper(this.swiperSlide, {
        slidesPerView: 'auto',
        loop: false,
        navigation: {
          nextEl: '.swiper-plan-list-'+ key + '+ .swiper-button-prev + .swiper-button-next',
          prevEl: '.swiper-plan-list-'+ key + '+ .swiper-button-prev',
        },
        watchOverflow: !slidable,
      });
    };


    this.mySwiper = null;
    this.checkBreakpoint = (e) => {
      if(e.media == '(max-width: 767px)'){
        if (e.matches) {
          //SP:スライドつけない
          this.slidable = false;
          document.querySelector('.p-plan-list-slider__button').classList.add('d-none');
          if(this.mySwiper){
            this.mySwiper.destroy(false, true);
            this.mySwiper = null;
          }
        }else if(!this.mySwiper){
          //PC:スライドつける
          this.slidable = true;
          document.querySelector('.p-plan-list-slider__button').classList.remove('d-none');
          this.initSwiper();
        }
      }
    }

    //SP
    this.mediaQuerySP = window.matchMedia('(max-width: 767px)');
    this.mediaQuerySP.addEventListener('change', this.checkBreakpoint, false);
    this.checkBreakpoint(this.mediaQuerySP);


  }
}
